import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const activityLogApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/activityLog",
      params,
    }),
};
